import api from 'services/api';
import {
  ICycle,
  IQueryParamsCycle,
  IQueryParamsPostCyclesCode,
  IResponseCyclesCode,
} from 'v2/resources/types/cycles';
import { HttpCodes } from 'v2/resources/types/httpCode';
import { DEFAULT_RESPONSE_CYCLES, DEFAULT_RESPONSE_CYCLES_CODE } from './types';

export const CyclesServices = {
  getCycles: async (queryParams: IQueryParamsCycle): Promise<ICycle[]> => {
    const response = await api.get('/dashboard/detailedPondsCyclesView', {
      params: queryParams,
    });
    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }

    return DEFAULT_RESPONSE_CYCLES;
  },
  getCycleCodes: async (): Promise<IResponseCyclesCode[]> => {
    const response = await api.get('/cycle-codes');
    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }
    return DEFAULT_RESPONSE_CYCLES_CODE;
  },
  postCycleCodes: async (
    querParams: IQueryParamsPostCyclesCode
  ): Promise<IResponseCyclesCode> => {
    const response = await api.post('/cycle-codes', {
      querParams,
    });
    if (response.status === HttpCodes.SUCCESS_CREATED) {
      return response.data;
    }
    return DEFAULT_RESPONSE_CYCLES_CODE[0];
  },
};
